import React, { useState } from "react";
import { Box } from "@mui/material";
import GridView from "./GridView";
import ListView from "./ListView";
import Filters from "../Filters";
import {
  getFileViewLocalStorage,
  setFileViewLocalStorage,
} from "../../../../../core/storage/localStorage";
import FilesDirectoryBreadcrumbs from "./FilesDirectoryBreadcrumbs";

function FilesList({
  category,
  status,
  fileType,
  query,
  sortOption,
  filteredCurrentDirectory,
  currentDirectory,
  handleSelectFile,
  handleDeleteFile,
  handleUpdateFile,
  handleSelectDirectory,
  handleSearchFiles,
  handleSortFiles,
  handleStatusChange,
  handleFileTypeChange,
  handleResetFilters,
  handleCategoryChange,
}) {
  const [view, setView] = useState(getFileViewLocalStorage());
  const isRootDirectory = !currentDirectory.current_path;
  const files = currentDirectory.files;

  return (
    <Box display="flex" flexDirection="column">
      {/* Breadcrumb above filters */}
      {!isRootDirectory && (
        <FilesDirectoryBreadcrumbs
          currentDirectory={currentDirectory}
          handleSelectDirectory={handleSelectDirectory}
        />
      )}
      <Filters
        files={files}
        category={category}
        status={status}
        fileType={fileType}
        query={query}
        sortOption={sortOption}
        view={view}
        onSearchFiles={handleSearchFiles}
        onSortFiles={handleSortFiles}
        onStatusChange={handleStatusChange}
        onFileTypeChange={handleFileTypeChange}
        onResetFilters={handleResetFilters}
        onViewChange={(value) => {
          setView(value);
          setFileViewLocalStorage(value);
        }}
        onCategoryChange={handleCategoryChange}
      />
      <Box mb={3} />
      {view === "grid" ? (
        <GridView
          filteredCurrentDirectory={filteredCurrentDirectory}
          handleSelectFile={handleSelectFile}
          handleDeleteFile={handleDeleteFile}
          handleUpdateFile={handleUpdateFile}
          handleSelectDirectory={handleSelectDirectory}
        />
      ) : (
        <ListView
          filteredCurrentDirectory={filteredCurrentDirectory}
          handleSelectFile={handleSelectFile}
          handleDeleteFile={handleDeleteFile}
          handleUpdateFile={handleUpdateFile}
          handleSelectDirectory={handleSelectDirectory}
        />
      )}
    </Box>
  );
}

export default FilesList;
